import React, { useState } from 'react';
import { History } from 'lucide-react';
import { useWorkspaceStore } from '../../store/workspaceStore';
import { isGitTracked } from '../../services/git/gitSyncStatus';
import { isTauri } from '../../utils/tauri';
import Tooltip from '../ui/Tooltip';
import ItemHistoryModal from './ItemHistoryModal';

/**
 * The clock in the request editor's header (git sync card 9): this request's
 * git history in place. Shown only when the open workspace syncs to a
 * repository or is tracked on this device — like an editor's file timeline,
 * it is there when there is a history to show.
 */
export default function RequestHistoryButton({ requestId, requestName }) {
  const workspace = useWorkspaceStore((s) => s.currentWorkspace);
  const [open, setOpen] = useState(false);
  if (!requestId || !isTauri() || !isGitTracked(workspace)) return null;
  return (
    <>
      <Tooltip content="History" side="bottom">
        <button
          type="button"
          onClick={() => setOpen(true)}
          className="request-header-save inline-flex items-center px-2 py-1 rounded-md bg-transparent text-gray-500 hover:text-gray-800 hover:bg-gray-100 transition-colors flex-shrink-0"
          aria-label="History of this request"
          data-testid="request-history-button"
        >
          <History size={14} strokeWidth={2} />
        </button>
      </Tooltip>
      {open && (
        <ItemHistoryModal
          isOpen
          onClose={() => setOpen(false)}
          workspace={workspace}
          itemId={requestId}
          itemName={requestName}
        />
      )}
    </>
  );
}
